<h2 class="cdk-visually-hidden">
  {{ 'research.profile.title.output' | translate }}
</h2>
@if (isOutputEmpty && !isPublicPage) {
  <div @opacityInAnimation class="output-empty">
    <exl-empty-state
      bodyFirstLine="research.output.list.empty.message.body.first"
      bodySecondLine="research.output.list.empty.message.body.second"
      header="research.output.list.empty.message.header"
      >
      @if (isResearcherDepositsEnabled() && media.is('gt-sm')) {
        <button
          [ariaLabel]="'research.aria.output.list.add.deposit' | translate"
          [gleam]="false"
          [isLarge]="true"
          [jellyOnHover]="true"
          espDepositFormTrigger
          mulo-funky-button
          >
          <mat-icon svgIcon="plus"></mat-icon>
          <span>{{ 'research.output.list.empty.add.first.output.button' | translate }}</span>
        </button>
      }
    </exl-empty-state>
  </div>
}
@if (!isOutputEmpty) {
  <mulo-nav-main-layout
    [navPosition]="media.is('xs') ? 'top' : 'left'"
    [navSize]="media.is('xs') ? 48 : media.is('md') ? 170 : 200"
    [stickyOffset]="48"
    navBehavior="sticky"
    >
    <div #contentNavParent slot="nav">
      @if (media.is('lt-sm')) {
        @if (!isLoading) {
          <mulo-breadcrumbs-nav
            (itemSelected)="onMobileFacetChange($event)"
            (navDirection)="tabDirection = $event"
            [allLabel]="'research.output.list.facet.mobile.all' | translate"
            [items]="profileOutputService.facetsForMobile"
            [selectedIndex]="selectedIndexForMobile"
            >
          </mulo-breadcrumbs-nav>
        } @else {
          <div @opacityOutAnimation class="content-nav-placholders" style="position: absolute; width: 100%">
            <content-loader
              [rtl]="i18nService.isLangRtl()"
              [style]="{ height: 180, width: 160 }"
              backgroundColor="#dddddd"
              foregroundColor="#eeeeee"
              viewBox="0,0,160,180"
              >
              <svg:rect height="7" rx="2" ry="2" width="80" x="14" y="18" />
              <svg:rect height="7" rx="2" ry="2" width="90" x="14" y="54" />
              <svg:rect height="7" rx="2" ry="2" width="80" x="14" y="92" />
              <svg:rect height="7" rx="2" ry="2" width="110" x="14" y="128" />
            </content-loader>
          </div>
        }
      }
      @if (media.is('gt-xs')) {
        @if (!isLoading) {
          <nav
            [disablePagination]="true"
            [muloVerticalTabs]="selectedIndex"
            [tabPanel]="tabPanel"
            [attr.aria-label]="'research.profile.section.output' | translate"
            class="content-nav is-scaling"
            color="primary"
            exlAutomationClass="output-nav"
            mat-tab-nav-bar
            >
            @for (tab of allNodes; track trackItem(i, tab); let i = $index) {
              @if (tab.level <= 1 || sameCatAsChosen(tab)) {
                <a
                  #rla="routerLinkActive"
                  (click)="updateSelectedIndex(tab)"
                  [active]="rla.isActive"
                  [class.has-children]="hasChildren(tab)"
                  [class.is-child]="tab.level !== 0"
                  [class.is-grandchild]="tab.level > 1"
                        [ngClass]="{
                            italic: tab.category.facet === 'drafts' || tab.category.facet === 'inProcess'
                        }"
                  [queryParams]="{ institution: institutionCode }"
                  [routerLink]="[tab.category.facet]"
                  mat-tab-link
                  routerLinkActive
                  >
                  <span class="cdk-visually-hidden">{{
                    'research.aria.output.list.output.view' | translate
                  }}</span>
                  <span>
                    <ng-container>{{ getOutputTitle(tab.category) | translate }}</ng-container>
                    <span class="tab-count">({{ tab.category.count }})</span>
                  </span>
                </a>
              }
            }
          </nav>
        } @else {
          <div @opacityOutAnimation class="content-nav-placholders" style="position: absolute; width: 100%">
            <content-loader
              [rtl]="i18nService.isLangRtl()"
              [style]="{ height: 180, width: 160 }"
              backgroundColor="#dddddd"
              foregroundColor="#eeeeee"
              viewBox="0,0,160,180"
              >
              <svg:rect height="7" rx="2" ry="2" width="80" x="14" y="18" />
              <svg:rect height="7" rx="2" ry="2" width="90" x="14" y="54" />
              <svg:rect height="7" rx="2" ry="2" width="80" x="14" y="92" />
              <svg:rect height="7" rx="2" ry="2" width="110" x="14" y="128" />
            </content-loader>
          </div>
        }
      }
    </div>
    <div class="padding-left-sm" slot="main">
      <div class="output-content" style="position: relative">
        <div class="list-toolbar">
          @if (!isPublicPage && isResearcherDepositsEnabled() && media.is('gt-sm')) {
            <button
              class="has-icon is-loud"
              color="primary"
              espDepositFormTrigger
              mat-button
              >
              <mat-icon svgIcon="plus"></mat-icon>
              <span>{{ 'research.output.list.add.deposit' | translate }}</span>
            </button>
          }
          @if (!isPublicPage || (isPublicPage && media.is('gt-xs'))) {
            <button
              (click)="exportAssets()"
              [disabled]="disableExportAll()"
              class="has-icon is-loud"
              color="primary"
              mat-button
              >
              <mat-icon class="mat-icon-rtl-mirror" svgIcon="export"></mat-icon>
              <span>{{ 'research.output.list.export.all' | translate }}</span>
            </button>
          }
          @if (displayApcButton()) {
            <button
              (click)="openApcForm()"
              class="has-icon is-loud"
              color="primary"
              mat-button
              >
              <mat-icon svgIcon="plus"></mat-icon>
              {{ 'research.output.list.action.apc.request' | translate }}
            </button>
          }
        </div>
        <div class="position-relative">
          <!-- optional pre-list content -->
          <ng-content select="slot-profile-list-before"></ng-content>
          <router-outlet #outlet="outlet"></router-outlet>
          <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
          <!-- optional post-list content -->
          <ng-content select="slot-profile-list-after"></ng-content>
        </div>
      </div>
    </div>
  </mulo-nav-main-layout>
}
